import { EmptyTableResults } from '@/components/Table/styles';
import { ORGANIZATION_USERS_TABLE_CONFIG } from '@/bundle/_MasterAdmin/ui/OrganizationUserTable/const';
import { TableType } from '@/components/Table/types/types';
import { NoResults } from '@/components/NoResults/NoResults';
import NoUsersIcon from '@/images/NoUsersIcon.svg?react';
import { getMasterAdminOrganizationUserDetailsPath } from '@/bundle/_MasterAdmin/_OrganizationUserDetailsPage/path/path';
import { InternalOrganizationListUserType } from '../../types/types';
import { useStatefulNavigation } from '@/hooks/useStatefulNavigation';
import { useResponsiveDevice } from '@/hooks/useResponsiveDevice';
import { MobileTable } from '@/components/Table/MobileTable/MobileTable';
import { DesktopTable } from '@/components/Table/DesktopTable';

export const OrganizationUserTable = ({
  items = [],
  isLoading = false,
}: TableType<InternalOrganizationListUserType>) => {
  const { navigateFrom } = useStatefulNavigation();
  const { isMobile } = useResponsiveDevice();

  const hasItems = !!items.length;
  const noUsers = !hasItems && !isLoading;

  const navigateToDetails = (item: InternalOrganizationListUserType) => {
    navigateFrom(getMasterAdminOrganizationUserDetailsPath(item.id));
  };

  if (noUsers) {
    return (
      <EmptyTableResults>
        <NoResults icon={<NoUsersIcon />} message='Please create your first user.' />
      </EmptyTableResults>
    );
  }

  return isMobile ? (
    <MobileTable
      config={ORGANIZATION_USERS_TABLE_CONFIG}
      items={items}
      isLoading={isLoading}
      onRowClick={navigateToDetails}
    />
  ) : (
    <DesktopTable
      config={ORGANIZATION_USERS_TABLE_CONFIG}
      items={items}
      isLoading={isLoading}
      onRowClick={navigateToDetails}
    />
  );
};
